<template>
  <div class="Deduction">
    <div class="Deduction-content">
      <el-tabs v-model="activeName" type="card">
        <el-tab-pane label="费用统计" name="Statistics">
          <Statistics :date-data="dateData" />
        </el-tab-pane>

        <el-tab-pane label="采购总费用" name="Procurement_fee">
          <Procurementfee :date-data="dateData" />
        </el-tab-pane>

        <el-tab-pane label="收益统计" name="profit" v-if="isShow">
          <Profit :date-data="dateData" />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import Statistics from "./Deduction/Statistics";
import Procurementfee from "./Deduction/Procurement_fee";
import Profit from "./Deduction/Profit";
export default {
  name: "Deduction",
  components: {
    Statistics,
    Procurementfee,
    Profit
  },
  data() {
    return {
      UserInfo: {},
      activeName: "Statistics",
      dateData: {}
    };
  },
  created() {
    this.UserInfo = JSON.parse(localStorage.getItem("role"));
    this.getThisMonth()
  },
  computed: {
    isShow() {
      const { type, system, superDepartmentName } = this.UserInfo
      const result = (type === 1 && system === 1) || (type === 1 && system === 5 && superDepartmentName === '财务部')
      const result2 = (type === 2 && system === 1) || (type === 2 && system === 5 && superDepartmentName === '财务部')

      return result || result2
    }
  },
  methods:{
    getThisMonth() {
      const nowDate = new Date()
      const nowTimeStamp = nowDate.getTime()
      const nowYear = nowDate.getFullYear()
      const nowMonth = nowDate.getMonth() + 1
      const nowDay = nowDate.getDate()

      const startTimeStamp = nowTimeStamp - (3600 * 1000 * 24 * 30)
      const startDate = new Date(startTimeStamp)
      const startYear = startDate.getFullYear()
      const startMonth = startDate.getMonth() + 1
      const startDay = startDate.getDate()

      this.dateData.startTime = `${ startYear }-${ startMonth }-${ startDay } 00:00:00`
      this.dateData.endTime = `${ nowYear }-${ nowMonth }-${ nowDay } 23:59:59`
    },
  }
};
</script>

<style lang="scss" scoped>
</style>
